module.exports = __webpack_public_path__ + "img/blue.767e0f70.png";